import { Common } from "apiEndPoints";
import { logger } from "utils";
import APIrequest from "../axios";

// Service functions related to common operations, such as fetching country and state data.
export const CommonService = {

  /**
 * Fetches country data.
 * @returns {Promise} A promise that resolves to the response data.
 */
  countryService: async () => {
    try {
      const payload = {
        ...Common.country,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

    /**
   * Fetches state data based on the provided query parameters.
   * @param {Object} queryParams - Query parameters for state data.
   * @returns {Promise} A promise that resolves to the response data.
   */
  stateService: async (queryParams) => {
    try {
      const payload = {
        ...Common.state,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

    /**
   * Fetches notification data based on the provided query parameters.
   * @param {Object} queryParams - Query parameters for notification data.
   * @returns {Promise} A promise that resolves to the response data.
   */
  getNotificationData: async (queryParams) => {
    try {
      const payload = {
        ...Common.getNotification,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
    /**
   * Fetches notification data based on the provided query parameters.
   * @param {Object} queryParams - Query parameters for notification data.
   * @returns {Promise} A promise that resolves to the response data.
   */
  getUnreadNotificationCount: async (queryParams) => {
    try {
      const payload = {
        ...Common.getUnreadNotificationCount,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
    /**
   * Update notification data.
   * @returns {Promise} A promise that resolves to the response data.
   */
    updateUnreadNotificationStatus: async () => {
    try {
      const payload = {
        ...Common.updateUnreadNotificationStatus,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
};
